import cx from 'classnames'
import { useContext } from 'react'

import { PrintShopFormContext } from '@lib/print/print-shop-form-context'
import { PrintShopFormStringsContext } from '@lib/print/print-shop-form-strings-context'
import { getShopFormStepTitle } from '@lib/print/text'

import ShopFormProgressIndicatorItem from './progress-indicator-item'

interface ShopFormProgressIndicatorProps {
  className?: string
}

const ShopFormProgressIndicator = ({
  className,
}: ShopFormProgressIndicatorProps) => {
  const { activeStepIndex, shopFormSteps } = useContext(PrintShopFormContext)
  const { shopFormStrings } = useContext(PrintShopFormStringsContext)

  if (shopFormSteps.length === 0) {
    return null
  }

  return (
    <div
      className={cx(
        'flex justify-center max-w-full py-4 border-b border-gray-light',
        className,
      )}
    >
      <div
        className="flex"
        style={{
          width: shopFormSteps.length * 85,
        }}
      >
        {shopFormSteps.map((shopFormStep) => {
          const title = getShopFormStepTitle(
            shopFormStrings,
            shopFormStep.props.stepType,
            shopFormStep.props.printSlot,
          )

          return (
            <ShopFormProgressIndicatorItem
              key={shopFormStep.props.stepIndex}
              title={title}
              isSelected={activeStepIndex >= shopFormStep.props.stepIndex}
              showLine={shopFormStep.props.stepIndex > 0}
              className="flex-1"
            />
          )
        })}
      </div>
    </div>
  )
}

export default ShopFormProgressIndicator
